import axios from "axios";
import { API } from "@/AppContext";

// Opaque per-browser id to stitch funnel events (identifies no one).
function sessionId() {
  try {
    let s = localStorage.getItem("chambanow_sid");
    if (!s) {
      s = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      localStorage.setItem("chambanow_sid", s);
    }
    return s;
  } catch {
    return null;
  }
}

// Fire-and-forget funnel event to our own backend (no third-party analytics).
export function trackEvent(event, props = {}) {
  try {
    const headers = {};
    const tok = typeof localStorage !== "undefined" ? localStorage.getItem("chambanow_token") : null;
    if (tok) headers.Authorization = `Bearer ${tok}`;
    const lang = typeof localStorage !== "undefined" ? localStorage.getItem("chambanow_lang") || undefined : undefined;
    axios.post(`${API}/analytics/event`, { event, props, session_id: sessionId(), lang }, { headers }).catch(() => {});
  } catch {
    /* never block the UI on analytics */
  }
}
